<template>
  <MeuCurriculo/>
</template>

<script>
import MeuCurriculo from './components/meuCurriculo.vue';

export default {
  name: 'App',
  components: {
    MeuCurriculo
  }
}
</script>

<style scoped>

</style>
